export default "__VITE_ASSET__C4eK3UBN__"